import FanProfileTrainingOverlayComponent from "./FanProfileTrainingOverlayComponent";

export default FanProfileTrainingOverlayComponent;